import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import UploadFile from './c/uploadFiles/UploadFiles';
import './fileDrop.scss';
import FilesToUploadList from "./c/filesToUploadList/FilesToUploadList";
import { primaryBlue } from 'theme/mainColors';
import { getAcceptedFileTypes } from 'shared/helpers/fileHelper';

const itemsColor = primaryBlue;

class FileDrop extends Component {
  constructor(props){
    super(props);
    this.accept = getAcceptedFileTypes(props.acceptedTypes);
    this.activeStyle = {
      border: '1px solid',
      borderColor: itemsColor
    };
    this.rejectStyle = {
      border: '1px solid',
      borderColor: 'red'
    };
  }

  handleSelectFileClick = () => {
    this.dropzone.open();
  };

  discardFile = (file) => {
    this.props.onDropFiles(this.props.acceptedFiles.filter(fileToCompare => (fileToCompare.name !== file.name)), this.props.rejectedFiles);
  };

  render() {
    const { multiple, onDropAccepted, onDropRejected, acceptedFiles, onDropFiles } = this.props;
    const filesLoaded = acceptedFiles.length > 0;

    const shouldRenderDropZone = (!filesLoaded && !multiple) || (multiple);
    return (
      <div>
        {
          shouldRenderDropZone &&
          <Dropzone
            activeStyle={ this.activeStyle }
            rejectStyle={ this.rejectStyle }
            disableClick
            ref={ (node) => { this.dropzone = node; } }
            onDrop={ onDropFiles }
            onDropAccepted={ onDropAccepted }
            onDropRejected={ onDropRejected }
            multiple={ multiple }
            accept={ this.accept }
          >
            <UploadFile onSelectFileClick={ this.handleSelectFileClick } itemsColor={ itemsColor } />
          </Dropzone>
        }
        {
          filesLoaded &&
          <FilesToUploadList acceptedFiles={ acceptedFiles } onDiscardFile={ this.discardFile }/>
        }
      </div>
    );
  }
}

FileDrop.propTypes = {
  acceptedTypes: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  multiple: PropTypes.bool,
  onDropRejected: PropTypes.func,
  onDropAccepted: PropTypes.func,
  acceptedFiles: PropTypes.arrayOf(PropTypes.object).isRequired,
  rejectedFiles: PropTypes.arrayOf(PropTypes.object).isRequired,
  onDropFiles: PropTypes.func.isRequired
};

FileDrop.defaultProps = {
  multiple: false,
  acceptedTypes: undefined,
  onDropRejected: () => null,
  onDropAccepted: () => null
};

export default FileDrop;



// WEBPACK FOOTER //
// ./src/shared/components/fileDrop/FileDrop.js